import React, { FC } from "react";

const DataSummary: FC = () => {
    return (
        <div>
            <div className={'data-summary-wrapper'} style={{ zIndex: 1 }}>
                <div className={'data-summary-title'}>
                    <div className={'data-summary-title-text'}>
                        NCDC Data Summary
                    </div>
                </div>
                <div className={'data-count-wrapper'}>
                    <div className={'data-count-item'}>
                        <div className={'data-count-item-title'}>
                            임상데이터
                        </div>
                        <div className={'data-count-item-value'}>
                            101.3K
                        </div>
                    </div>
                    <div className={'data-count-item'}>
                        <div className={'data-count-item-title'}>
                            유전체데이터
                        </div>
                        <div className={'data-count-item-value'}>
                            50.1K
                        </div>
                    </div>
                    <div className={'data-count-item'}>
                        <div className={'data-count-item-title'}>
                            영상데이터
                        </div>
                        <div className={'data-count-item-value'}>
                            34.6K
                        </div>
                    </div>
                    <div className={'data-count-item'}>
                        <div className={'data-count-item-title'}>
                            공공데이터
                        </div>
                        <div className={'data-count-item-value'}>
                            87.2K
                        </div>
                    </div>
                </div>
            </div>
            <div className={'data-summary-text-wrapper'}>
                <div className={'data-summary-text-title'}>국가암데이터센터</div>
                <div className={'data-summary-text-eng'}>National Cancer Data Center</div>
                <div className={'data-summary-text-desc'}>세계 최대 암빅데이터 구축<br/>및 활용기반 조성</div>
            </div>
        </div>
    );
}

export default DataSummary;
